export default __webpack_public_path__ + "static/media/logo-flexge.9a434930.png";